import React from "react";
import { Col, Row } from "react-bootstrap";

export default function CustomProd() {
    return (
        <>
            <div className="aboutus_bg">
                <div className="aboutus-img-content">
                    <h1>Custom Private Label, Printing & Packaging Services</h1>
                </div>
            </div>
            <div className="container my-5">
                <div className="row">
                    {/* Main Content Section */}
                    <div className="col-lg-8 vendor-main-content">
                        <img
                            src="images/print1.jpg"
                            alt="Emergency Fund Management"
                            className="img-fluid"
                        />
                        <p>Transform your product line with bespoke packaging, professional printing, and eye-catching labels that build brand loyalty and stand out on shelves.</p>
                        <h2 style={{ fontWeight: 'bold' }}>Our Services</h2>
                        <p>
                            <ul>
                                <li><b>Custom product labels with high-quality printing</b> <br /><br /></li>
                                <li><b>Unique packaging design aligned to your brand identity</b> <br /><br /></li>
                                <li><b>Eco-friendly and sustainable packaging options</b> <br /><br /></li>
                                <li><b>Promotional print materials: flyers, brochures, business cards</b> <br /><br /></li>
                                <li><b>Variable data printing for personalized marketing</b> <br /><br /></li>
                                <li><b>Flexible print runs for startups to large enterprises</b></li>
                            </ul>
                        </p>
                    </div>

                    {/* Sidebar Section */}
                    <div className="col-lg-4 vendor-sidebar">
                        {/* Why Choose Us */}
                        <div className="vendor-section vendor-services">
                            <h3 style={{ fontWeight: 'bold' }}>Benefits</h3>
                            <ul>
                                <li><span class="arrow">➤</span>Professional, consistent brand visuals</li>
                                <li><span class="arrow">➤</span>Enhanced customer appeal and recognition</li>
                                <li><span class="arrow">➤</span>Coordinated marketing collateral support</li>
                                <li><span class="arrow">➤</span>Cost-effective print solutions tailored to your needs</li>
                            </ul>
                        </div>

                        {/* Latest Posts */}
                        <div className="vendor-section vendor-latest-posts" style={{ marginBottom: '20px' }}>
                            <img
                                src="images/print2.jpg"
                                alt="Emergency Fund Management"
                                className="img-fluid"
                            />

                        </div>
                        {/* Contact Info */}
                        {/* <div className="vendor-section vendor-contact-info">
                            <h3 style={{fontWeight:'bold'}}>Contact Info</h3>
                            <p>
                                <span> <i class="fa-solid fa-location-dot fa-xl" style={{ color: '#b80404' }}></i> </span>&nbsp;&nbsp;
                                <span>934 McCowan Road, Toronto M1P 3H6</span></p>
                            <p><i class="fa-solid fa-headset fa-xl" style={{ color: '#b80404' }}></i>&nbsp;&nbsp;+1 (647) 716-1330</p>

                            <p> <i class="fa-solid fa-envelope fa-xl" style={{ color: '#b80404' }}></i>&nbsp;&nbsp;info@rojancanada.com</p>

                        </div> */}
                    </div>
                </div>
            </div >
        </>
    );
}
